import Vue from 'vue';
import Icon from '@/Components/UI/Icon';
import Modal from '@/Components/UI/Modal';
import Notice from '@/Components/UI/Notice';
import CheckboxField from '@/Components/UI/Form/CheckboxField';
import vDatePicker from '@/Components/UI/Form/vDatePicker';
import SearchForm from '@/Components/UI/Form/SearchForm';
import Switcher from '@/Components/UI/Form/Switcher';
import TableSortBtn from '@/Components/UI/Buttons/TableSortBtn';
import DurationField from '@/Components/UI/Form/DurationField';

Vue.component('Icon', Icon);
Vue.component('Modal', Modal);
Vue.component('Notice', Notice);
Vue.component('CheckboxField', CheckboxField);
Vue.component('vDatePicker', vDatePicker);
Vue.component('SearchForm', SearchForm);
Vue.component('Switcher', Switcher);
Vue.component('TableSortBtn', TableSortBtn);
Vue.component('DurationField', DurationField);

import SimplePreloader from '@/Components/SimplePreloader';
import UserControls from '@/Components/UI/UserControls';
import TheConfirm from '@/Components/Alerts/TheConfirm';

Vue.component('SimplePreloader', SimplePreloader);
Vue.component('UserControls', UserControls);
Vue.component('TheConfirm', TheConfirm);

import StudentListHeader from '@/Components/StudentsList/StudentListHeader';
import StudentTable from '@/Pages/Student/Blocks/Student/StudentTable';

Vue.component('StudentListHeader', StudentListHeader);
Vue.component('StudentTable', StudentTable);

import TheEmptyTable from '@/Components/Layout/TheEmptyTable';
Vue.component('TheEmptyTable', TheEmptyTable);
